import useSWR from "swr";
import {getConfig} from "../_configs/AppConfig";
import {useStores} from "../stores/useStores";

const {publicRuntimeConfig} = getConfig();

export const gearLaunchSupportEmail = "support@schoolblocksgl.com";

export const useGearLaunchShop = () => {
    const {organizationStore} = useStores();

    const {data, isLoading, mutate} = useSWR(`fetch-shop-${organizationStore.currentOrganization.id}`, async () => {
        try {
            const res = await fetch(`${publicRuntimeConfig.GEARLAUNCH_API_URL}/widget/${organizationStore.currentOrganization.id}`,
                                    {
                                        method: 'GET',
                                    },);
            const result = await res.json();
            return result;
        } catch (e) {
            console.error(e);
            return {
                e,
                message: "Error fetching shop data.",
            }
        }
    }, {
        revalidateOnMount: true,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return {data, isLoading, mutate}
}
